// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles_buttons__F6tAx","divPadding":"styles_divPadding__E24Nx"};